module.exports = __webpack_public_path__ + "img/headerLogo.a04450a9.png";